import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

// Launched from the home screen? (iOS Safari also exposes navigator.standalone)
if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
  document.documentElement.classList.add('is-standalone');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
